import { createSlice, PayloadAction, createAsyncThunk } from "@reduxjs/toolkit";
import { getAndValidationDate } from "@api/index";

export interface bornOnBeforeAndAfterDateProps {
  displayBeforeDate: string;
  beforeDate: number;
  displayAfterDate: string;
  afterDate: number;
}

export interface Insurer {
  id: number;
  code: string;
  label: string;
}

export interface Notification {
  title: string;
  description: string;
  type?: string;
}

export interface Step1State {
  floatIconShow: boolean;
  bornOnBeforeAndAfterDate: bornOnBeforeAndAfterDateProps;
  whomToBuy: string;
  hasExistingPlan: "yes" | "no" | "not_sure";
  existingPlan: string;
  insurerList: Insurer[];
  apiError: string;
  notifications: Notification[];
}

const initialState: Step1State = {
  floatIconShow: true,
  bornOnBeforeAndAfterDate: {
    displayBeforeDate: "",
    beforeDate: 0,
    displayAfterDate: "",
    afterDate: 0,
  },
  whomToBuy: "",
  hasExistingPlan: "not_sure",
  existingPlan: "",
  insurerList: [],
  apiError: "",
  notifications: [],
};

// export const getValidationDate = createAsyncThunk(
//   "SHIELD_STARTER-Step1/request",
//   async () => {
//     // const response = await getAndValidationDate();
//     // return { ...response.data };
//   }
// );

const step1Slice = createSlice({
  name: "SHIELD_STARTER-Step1",
  initialState,
  reducers: {
    updateWhomToBuy: (state, action: PayloadAction<string>) => {
      state.whomToBuy = action.payload;
    },
    updateHasExistingPlan: (
      state,
      action: PayloadAction<"yes" | "no" | "not_sure">
    ) => {
      state.hasExistingPlan = action.payload;
    },
    updateExistingPlan: (state, action: PayloadAction<string>) => {
      state.existingPlan = action.payload;
    },
    updateToDefaultStateStep1: (state, action: PayloadAction<string>) => ({
      ...initialState,
    }),
    updateInsurerList: (state, action: PayloadAction<Insurer[]>) => {
      state.insurerList = action.payload;
    },
    updateApiError: (state, action: PayloadAction<string>) => {
      state.apiError = action.payload;
    },
    updateFloatIconShow: (state, action: PayloadAction<boolean>) => {
      state.floatIconShow = action.payload;
    },
    updateBornOnBeforeAndAfterDate: (state, action: PayloadAction<any>) => {
      state.bornOnBeforeAndAfterDate = action.payload;
    },
    addNotification: (state, action: PayloadAction<Notification>) => {
      state.notifications.push(action.payload);
    },
    removeNotification: (state, action: PayloadAction<Notification>) => {
      state.notifications = state.notifications.filter(
        (notification) => notification.title !== action.payload.title
      );
    },
    clearNotifications: (state) => {
      state.notifications = [];
    },
  },
  // extraReducers: (builder) => {
  //   builder.addCase(getValidationDate.fulfilled, (state, { payload }) => ({
  //     ...state,
  //     bornOnBeforeAndAfterDate: {
  //       ...initialState.bornOnBeforeAndAfterDate,
  //       ...payload,
  //     },
  //   }));
  // },
});

export const {
  updateWhomToBuy,
  updateExistingPlan,
  updateHasExistingPlan,
  updateToDefaultStateStep1,
  updateInsurerList,
  updateApiError,
  updateFloatIconShow,
  updateBornOnBeforeAndAfterDate,
  addNotification,
  removeNotification,
  clearNotifications,
} = step1Slice.actions;

export default step1Slice.reducer;
